import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDottedCircle = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 1.5048A6.5 6.5 0 0 1 8.25 1.5048",
			stroke: "currentColor",
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 1.5048A6.5 6.5 0 0 1 8.25 1.5048",
			stroke: "currentColor",
			strokeLinecap: "square",
			transform: "rotate(30 8 8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 1.5048A6.5 6.5 0 0 1 8.25 1.5048",
			stroke: "currentColor",
			strokeLinecap: "square",
			transform: "rotate(60 8 8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 1.5048A6.5 6.5 0 0 1 8.25 1.5048",
			stroke: "currentColor",
			strokeLinecap: "square",
			transform: "rotate(90 8 8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 1.5048A6.5 6.5 0 0 1 8.25 1.5048",
			stroke: "currentColor",
			strokeLinecap: "square",
			transform: "rotate(120 8 8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 1.5048A6.5 6.5 0 0 1 8.25 1.5048",
			stroke: "currentColor",
			strokeLinecap: "square",
			transform: "rotate(150 8 8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 1.5048A6.5 6.5 0 0 1 8.25 1.5048",
			stroke: "currentColor",
			strokeLinecap: "square",
			transform: "rotate(180 8 8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 1.5048A6.5 6.5 0 0 1 8.25 1.5048",
			stroke: "currentColor",
			strokeLinecap: "square",
			transform: "rotate(210 8 8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 1.5048A6.5 6.5 0 0 1 8.25 1.5048",
			stroke: "currentColor",
			strokeLinecap: "square",
			transform: "rotate(240 8 8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 1.5048A6.5 6.5 0 0 1 8.25 1.5048",
			stroke: "currentColor",
			strokeLinecap: "square",
			transform: "rotate(270 8 8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 1.5048A6.5 6.5 0 0 1 8.25 1.5048",
			stroke: "currentColor",
			strokeLinecap: "square",
			transform: "rotate(300 8 8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.75 1.5048A6.5 6.5 0 0 1 8.25 1.5048",
			stroke: "currentColor",
			strokeLinecap: "square",
			transform: "rotate(330 8 8)"
		})
	]
});
export default SvgDottedCircle;
